import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OlaMaps } from 'olamaps-web-sdk';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { OlaMapsPredictionResponse } from 'src/app/real-estate/Interface & Service/olaMaps/olaMaps.interface';
import { OlaMapsGeocodingResponse } from 'src/app/real-estate/Interface & Service/olaMaps/olaMapsGeoCoding.interface';
import { environment } from 'src/environment/environment';

const olaMaps = new OlaMaps({
  apiKey: environment.olaAPI,
})

@Component({
  selector: 'app-view-on-map',
  templateUrl: './view-on-map.component.html',
  styleUrls: ['./view-on-map.component.css']
})
export class ViewOnMapComponent {
  @Input({ required: true }) latitudeControl!: AbstractControl;
  @Input({ required: true }) longitudeControl!: AbstractControl;
  @Input() pincode!: AbstractControl;
  @Output() locationSelected = new EventEmitter<{ lat: number, lng: number, place?: string }>();
  private http = inject(HttpClient);
  suggestions: any[] = [];
  selectedPlace: string = "";
  olaSearchControl = new FormControl('');
  myMap!: any;
  olaMarker: any;
  olaPopUp: any;
  latitude: number = 0;
  longitude: number = 0;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {

    if (this.latitudeControl.value && this.latitudeControl.value !== 0 && this.longitudeControl.value && this.longitudeControl.value !== 0) {
      this.latitude = this.latitudeControl.value;
      this.longitude = this.longitudeControl.value;
      // this.intiliazeOlaMaps();
    } else if (this.pincode?.value) {
      this.getLngLatByPincode();
    }



    this.olaSearchControl.valueChanges
      .pipe(
        debounceTime(500), // wait 500ms after typing
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        if (searchTerm && searchTerm.trim()) {
          this.getAutocomplete(searchTerm); // call your Ola Maps API search
        }
      });
  }

  ngAfterViewInit(): void {
    this.intiliazeOlaMaps();
  }

  ngOnDestroy(): void {
    this.updateCoordinates(this.longitude, this.latitude)
  }

  intiliazeOlaMaps() {
    this.myMap = olaMaps.init({
      style: "https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json",
      container: 'map',
      center: [this.latitude, this.longitude],
      zoom: 15,
    });


    const popup = olaMaps.addPopup({ offset: [0, -30], anchor: 'bottom' }).setHTML('<div>This is a simple Popup</div>')

    this.olaMarker = olaMaps
      .addMarker({
        offset: [0, 6],
        anchor: 'bottom',
        color: 'red',
        draggable: true,
      })
      .setLngLat([this.latitude, this.longitude])
      .setPopup(popup)
      .addTo(this.myMap)

  }

  getAutocomplete(query: string) {
    let url = `https://api.olamaps.io/places/v1/autocomplete?input=${encodeURIComponent(query)}&radius=1&strictbounds=true&api_key=${environment.olaAPI}`;

    this.http.get<OlaMapsPredictionResponse>(url).subscribe(res => {
      this.suggestions = res.predictions || [];
    });
  }



  // selectPlace(place: any) {
  //   console.log('place',place)
  //   this.longitude = place.geometry.location.lng;
  //   this.latitude = place.geometry.location.lat;
  //   // this.placeHeading = place.structured_formatting.main_text
  //   this.selectedPlace = place.structured_formatting.main_text+', '+place.structured_formatting.secondary_text;
  //   this.myMap = olaMaps.init({
  //     style: "https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json",
  //     container: 'map',
  //     center: [this.longitude, this.latitude],
  //     zoom: 15,
  //   });

  //   this.olaMarker.remove();

  //   this.olaMarker = olaMaps
  //     .addMarker({
  //       offset: [0, 6],
  //       anchor: 'bottom',
  //       color: 'red',
  //       draggable: true,
  //     })
  //     .setLngLat([this.longitude, this.latitude])
  //     .addTo(this.myMap)


  //   this.updateCoordinates(this.longitude, this.latitude);


  //   this.olaSearchControl.setValue(place.structured_formatting.main_text, { emitEvent: false });
  //   this.suggestions = [];
  // }

  selectPlace(place: any) {
  this.latitude = Number(place.geometry.location.lat);
  this.longitude = Number(place.geometry.location.lng);

  this.selectedPlace =
    (place.structured_formatting?.main_text || "") +
    ", " +
    (place.structured_formatting?.secondary_text || "");

  this.myMap = olaMaps.init({
    style: "https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json",
    container: "map",
    center: [this.longitude, this.latitude],
    zoom: 15,
  });

  if (this.olaMarker) {
    this.olaMarker.remove();
  }

  this.olaMarker = olaMaps
    .addMarker({
      offset: [0, 6],
      anchor: "bottom",
      color: "red",
      draggable: true,
    })
    .setLngLat([this.longitude, this.latitude])
    .addTo(this.myMap);

  // FIX: correct order lat, lng
  this.updateCoordinates(this.latitude, this.longitude);

  this.olaSearchControl.setValue(this.selectedPlace, { emitEvent: false });
  this.suggestions = [];
}

  getLngLatByPincode() {
    const pincode = this.pincode?.value;
    if (!pincode) return;

    let url = `https://api.olamaps.io/places/v1/geocode?address=${pincode}&language=English&api_key=${environment.olaAPI}`;

    this.http.get<OlaMapsGeocodingResponse>(url).subscribe(res => {
      const firstPrediction = res.results[0];
      this.latitude = firstPrediction.geometry.location.lat;
      this.longitude = firstPrediction.geometry.location.lng;

      if (this.myMap) {
        // Center map to pincode location
        this.myMap.setCenter([this.longitude, this.latitude]);
      } else {
        // If map is not initialized yet, initialize it
        this.intiliazeOlaMaps();
      }

      // Remove old marker if exists
      if (this.olaMarker) {
        this.olaMarker.remove();
      }

      // Add a new Ola marker at the pincode location
      this.olaMarker = olaMaps
        .addMarker({
          offset: [0, 6],
          anchor: 'bottom',
          color: 'red',
          draggable: true,
        })
        .setLngLat([this.longitude, this.latitude])
        .addTo(this.myMap);


      // Update form controls
      this.updateCoordinates(this.latitude, this.longitude);
    });
  }




  updateCoordinates(lat: number, lng: number) {
    this.latitudeControl.setValue(lat);
    this.longitudeControl.setValue(lng);
  }

  // confirmLocation() {

  //   this.latitudeControl.setValue(this.latitude);
  //   this.longitudeControl.setValue(this.longitude);

  //   // emit event for parent listeners
  //   this.locationSelected.emit({ lat: this.latitude, lng: this.longitude ,place:this.selectedPlace});

  //   console.log("Confirmed:", this.latitude, this.longitude, this.selectedPlace);

  //   // close the modal and pass back the coords
  //       this.activeModal.close({
  //     lat: this.latitude,
  //     lng: this.longitude,
  //     place: this.selectedPlace
  //   });

  // }

  confirmLocation() {
  this.latitudeControl.setValue(this.latitude);
  this.longitudeControl.setValue(this.longitude);

  const selectedLocation = {
    lat: this.latitude,
    lng: this.longitude,

    // send both names, so old/new parent code both work
    place: this.selectedPlace,
    address: this.selectedPlace,
    fullAddress: this.selectedPlace,
  };

  this.locationSelected.emit(selectedLocation);

  this.activeModal.close(selectedLocation);
}



}
